import { Method } from 'axios';
import api from 'Cloud/Application/api';
import { APICallV4 } from 'reactApp/api/APICall';
import { apiMigrateWeblinksV2ToV4 } from 'reactApp/appHelpers/featuresHelpers';
import { promisifyDeferredCall } from 'reactApp/utils/helpers';

const method = 'weblinks/domestic';

class WeblinksDomesticOnAPIV4Call extends APICallV4 {
    _method = method;
    _type: Method = 'post';
}

export const weblinksDomesticOnApiCall = (params: Record<string, any>): Promise<unknown> => {
    if (apiMigrateWeblinksV2ToV4.domestic) {
        return new WeblinksDomesticOnAPIV4Call().makeRequest({
            weblink_id: params.weblink,
            enable: true,
        });
    }

    return promisifyDeferredCall(api.weblinks.domestic.on, params);
};
